import { getApiBaseUrl } from '../config/apiBase';

/**
 * @param {'snake'|'memory'|'invaders'|'slots'|'poker'|'blackjack'} game
 * @returns {Promise<{ monthKey: string, entries: Array<{ name: string, score: number, createdAt?: string }>, unavailable?: boolean }>}
 */
export async function fetchMinisiteLeaderboard(game) {
  const base = getApiBaseUrl();
  const url = `${base}/api/minisite-leaderboard?game=${encodeURIComponent(game)}`;
  const r = await fetch(url);
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.error || `HTTP ${r.status}`);
  }
  return r.json();
}

/**
 * @param {'snake'|'memory'|'invaders'|'slots'|'poker'|'blackjack'} game
 * @param {string} name
 * @param {number} score
 */
export async function submitMinisiteLeaderboard(game, name, score) {
  const base = getApiBaseUrl();
  const r = await fetch(`${base}/api/minisite-leaderboard`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ game, name: String(name).trim(), score }),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) {
    throw new Error(data.error || `HTTP ${r.status}`);
  }
  return data;
}
